import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios from '@pepper/utils/src/function/axiosInstance'

type Props = {
  items: {
    id: string
    workflow_status_id: string
  }[]
  companyId: string
}

export function useBulkUpdateItemStatus() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      items,
      companyId,
    }: Props): Promise<BulkUpdateResponse> => {
      const response = await axios.put(`items/workflow-status`, {
        items,
        company_id: companyId,
      })
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['workflow-log'])
    },
  })
}
